export default "__VITE_ASSET__CeHNDCUk__"